import Vue from 'vue'
import Router from 'vue-router'

import Main from '@/components/Main'

// 新闻资讯
import Secondary from '@/components/Secondary'
// 新闻列表
import New_list from '@/components/New_list'
// 新闻详细
import New_detail from '@/components/New_detail'

// // 游戏资料
// import GameInformation from '@/components/GameInformation'
// // 名将录
// import RecordOfFamousGenerals from '@/components/game-information/RecordOfFamousGenerals'
// // 武将排行
// import RankingOfGenerals from '@/components/game-information/RankingOfGenerals'
// // 装备
// import EquipmentIntroduction from '@/components/game-information/EquipmentIntroduction'
// // 士兵类型
// import SoldierType from '@/components/game-information/SoldierType'
// // 持续状态
// import PersistentState from '@/components/game-information/PersistentState'


Vue.use(Router)

export default new Router({
    mode: "history",
    routes: [
        {
            path: '/',
            name: 'index',
            component: Main
        },
        {
            path: '/secondary',
            redirect: '/new_list',
            name: 'secondary',
            component: Secondary,
            children: [
                {
                    path: '/new_list',
                    name: 'new_list',
                    component: New_list,
                },
                {
                    path: '/new_detail',
                    name: 'new_detail',
                    component: New_detail
                },
            ]
        },
        // {
        //     path: '/GameInformation',
        //     redirect: '/名将录',
        //     name: 'Game-Information',
        //     component: GameInformation,
        //     children: [
        //         {
        //             path: '/名将录',
        //             name: '名将录',
        //             component: RecordOfFamousGenerals,
        //         },
        //         {
        //             path: '/名将录/:name',
        //             name: '名将录',
        //             component: () => import('@/components/game-information/GeneralsDetail.vue')
        //         },
        //         {
        //             path: '/武将排行',
        //             name: '武将排行',
        //             component: RankingOfGenerals
        //         },
        //         {
        //             path: '/装备',
        //             name: '装备',
        //             component: EquipmentIntroduction
        //         },
        //         {
        //             path: '/装备/:name',
        //             name: '装备',
        //             component: () => import('@/components/game-information/EquipDetail.vue')
        //         },
        //         {
        //             path: '/士兵类型',
        //             name: '士兵类型',
        //             component: SoldierType
        //         },
        //         {
        //             path: '/持续状态',
        //             name: '持续状态',
        //             component: PersistentState
        //         }
        //     ]
        // }
    ]
})



// WEBPACK FOOTER //
// ./src/router/index.js